(function () {
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
  var toggle = document.querySelector('.menu-toggle');
  var menu = document.getElementById('SiteMenu');
  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      var open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
    menu.addEventListener('click', function (e) {
      if (e.target.closest('a')) { menu.classList.remove('is-open'); toggle.setAttribute('aria-expanded', 'false'); }
    });
  }
  document.querySelectorAll('.has-sub').forEach(function (item) {
    var btn = item.querySelector('.sub-toggle');
    if (!btn) return;
    var setOpen = function (open) { item.classList.toggle('is-open', open); btn.setAttribute('aria-expanded', String(open)); };
    btn.addEventListener('click', function (e) { e.stopPropagation(); setOpen(!item.classList.contains('is-open')); });
    item.addEventListener('keydown', function (e) { if (e.key === 'Escape') { setOpen(false); btn.focus(); } });
    item.addEventListener('mouseleave', function () { if (window.matchMedia('(min-width: 961px)').matches) setOpen(false); });
  });
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.has-sub.is-open').forEach(function (item) {
      if (!item.contains(e.target)) { item.classList.remove('is-open'); item.querySelector('.sub-toggle').setAttribute('aria-expanded', 'false'); }
    });
  });
  // Hebrew messages for the browser's built-in form validation
  var heMsg = function (el) {
    var v = el.validity;
    if (el.type === 'checkbox' && v.valueMissing) return 'צריך לסמן את התיבה כדי להמשיך.';
    if (v.valueMissing) return el.type === 'email' ? 'צריך להזין כתובת מייל.' : 'זה שדה חובה.';
    if (v.typeMismatch && el.type === 'email') return 'כתובת המייל לא נראית תקינה.';
    return '';
  };
  document.addEventListener('invalid', function (e) {
    var el = e.target;
    if (el.setCustomValidity) { el.setCustomValidity(''); if (!el.validity.valid) el.setCustomValidity(heMsg(el)); }
  }, true);
  ['input', 'change'].forEach(function (ev) {
    document.addEventListener(ev, function (e) { if (e.target.setCustomValidity) e.target.setCustomValidity(''); }, true);
  });
})();

// ---------- motion ----------
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  var root = document.documentElement;
  root.classList.add('anim');
  var once = function (els, fn, opts) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); fn(e.target); } });
    }, opts || { threshold: .15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  };
  var main = document.getElementById('MainContent') || document.body;

  // 1. sections and cards fade up as they enter; cards in a row arrive one after another
  var rv = [];
  main.querySelectorAll('.block .sec-head, .block .shell > .more, .block .shell > .ctas').forEach(function (el) { rv.push(el); });
  main.querySelectorAll('.services, .work, .reviews, .pains, .values, .case, .proof-in, .sl-pains, .sl-topics, .faq, .about').forEach(function (g) {
    var kids = g.classList.contains('faq') || g.classList.contains('about') ? [g] : Array.prototype.slice.call(g.children);
    kids.forEach(function (k, i) { k.style.setProperty('--d', Math.min(i, 5) * .09 + 's'); rv.push(k); });
  });
  rv.forEach(function (el) { el.classList.add('rv'); });
  once(rv, function (el) {
    el.classList.add('in');
    // hand transforms back to hover effects once the entrance is done
    setTimeout(function () { el.classList.remove('rv', 'in'); el.style.removeProperty('--d'); }, 1400);
  });

  // 2. section labels ("// עבודות") type themselves with a blinking caret
  var kicks = Array.prototype.filter.call(main.querySelectorAll('.block .kicker'), function (k) { return !k.children.length && k.textContent.trim(); });
  kicks.forEach(function (k) { k.dataset.full = k.textContent; k.setAttribute('aria-label', k.textContent); k.style.minHeight = k.offsetHeight + 'px'; k.textContent = ''; });
  once(kicks, function (k) {
    var full = k.dataset.full, i = 0, c = document.createElement('span');
    c.className = 'k-caret'; c.setAttribute('aria-hidden', 'true'); k.appendChild(c);
    (function t() {
      if (i <= full.length) { k.firstChild && k.firstChild.nodeType === 3 ? k.firstChild.data = full.slice(0, i) : k.insertBefore(document.createTextNode(full.slice(0, i)), c); i++; setTimeout(t, 45 + Math.random() * 40); }
      else setTimeout(function () { c.remove(); }, 1800);
    })();
  }, { threshold: 1 });

  // 3. highlighter under the hero line and page titles
  once(Array.prototype.slice.call(document.querySelectorAll('.hero h1 .w3, .page-hero h1 > span')), function (el) { el.classList.add('in'); }, { threshold: .6 });

  // 4. process line fills, dots pop in order
  var steps = Array.prototype.slice.call(main.querySelectorAll('.steps'));
  steps.forEach(function (s) { Array.prototype.forEach.call(s.children, function (li, i) { li.style.setProperty('--i', i); }); });
  once(steps, function (s) { s.classList.add('in'); }, { threshold: .35 });

  // 5. "15 years" counts up
  once(Array.prototype.slice.call(document.querySelectorAll('.hero-exp b')).filter(function (b) { return /^\d+$/.test(b.textContent.trim()); }), function (b) {
    var to = +b.textContent.trim(), t0 = null;
    b.style.minWidth = b.offsetWidth + 'px';
    (function f(ts) { t0 = t0 || ts; var p = Math.min((ts - t0) / 2200, 1); b.textContent = Math.round(to * (1 - Math.pow(1 - p, 3))); if (p < 1) requestAnimationFrame(f); })(performance.now());
  }, { threshold: .8 });

  // 6. on touch screens there's no hover, so work screenshots scroll when the card is centred on screen
  if (window.matchMedia('(hover: none)').matches) {
    var pio = new IntersectionObserver(function (es) { es.forEach(function (e) { e.target.classList.toggle('peek', e.isIntersecting); }); }, { rootMargin: '-35% 0px -35% 0px' });
    document.querySelectorAll('.proj').forEach(function (p) { if (p.querySelector('img.tall')) pio.observe(p); });
  }
})();

// ---------- reviews carousel: arrows + gentle autoplay ----------
(function () {
  document.querySelectorAll('[data-car-auto]').forEach(function (track) {
    var nav = document.querySelector('[data-car="' + track.id + '"]');
    if (!nav) return;
    var rtl = getComputedStyle(track).direction === 'rtl';
    var prev = nav.querySelector('[data-dir="prev"]'), next = nav.querySelector('[data-dir="next"]');
    var step = function () { var c = track.firstElementChild; return c ? c.getBoundingClientRect().width + 20 : track.clientWidth; };
    var max = function () { return track.scrollWidth - track.clientWidth; };
    var go = function (dir) { track.scrollBy({ left: dir * step() * (rtl ? -1 : 1), behavior: 'smooth' }); };
    var update = function () { var pos = Math.abs(track.scrollLeft); prev.disabled = pos < 4; next.disabled = pos > max() - 4; nav.hidden = max() < 4; };
    var paused = false, stopped = false;
    nav.addEventListener('click', function (e) { var b = e.target.closest('[data-dir]'); if (!b) return; stopped = true; go(b.dataset.dir === 'next' ? 1 : -1); });
    ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) { track.addEventListener(ev, function () { paused = true; if (ev === 'touchstart') stopped = true; }, { passive: true }); });
    ['mouseleave', 'focusout'].forEach(function (ev) { track.addEventListener(ev, function () { paused = false; }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var visible = false;
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }, { threshold: .4 }).observe(track);
    setInterval(function () {
      if (stopped || paused || !visible || document.hidden) return;
      if (Math.abs(track.scrollLeft) > max() - 4) track.scrollTo({ left: 0, behavior: 'smooth' }); else go(1);
    }, 6000);
  });
})();
